import { LinkDescriptor } from '@remix-run/react/dist/links';

export const KansasFontLinks: LinkDescriptor[] = [
	{ rel: 'preconnect', href: 'https://use.typekit.net', crossOrigin: 'anonymous' },
	{ rel: 'preconnect', href: 'https://p.typekit.net', crossOrigin: 'anonymous' },
	{ rel: 'stylesheet', href: 'https://use.typekit.net/yfh6vvz.css' },
];

export * from './colours';
